import { render } from "./DebugWindow.vue?vue&type=template&id=7e1db896&scoped=true"
import script from "./DebugWindow.vue?vue&type=script&lang=js"
export * from "./DebugWindow.vue?vue&type=script&lang=js"

import "./DebugWindow.vue?vue&type=style&index=0&id=7e1db896&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e1db896"

export default script